import React from 'react';
import { Star, ShieldCheck, Truck, MapPin } from 'lucide-react';
import { testimonials } from '../../data/testimonials';
import { howItWorks } from '../../data/special';

const TRUST = [
  { Icon: Star, text: '5-star rated' },
  { Icon: Truck, text: 'We come to you' },
  { Icon: ShieldCheck, text: 'Fully insured' },
  { Icon: MapPin, text: 'Albuquerque local' },
];

export const TrustRow = () => (
  <div className="flex flex-wrap justify-center gap-x-8 gap-y-3" data-testid="special-trust-row">
    {TRUST.map(({ Icon, text }) => (
      <span key={text} className="inline-flex items-center gap-2 text-sm font-semibold text-neutral-700">
        <Icon className="w-4 h-4 text-red-600" />{text}
      </span>
    ))}
  </div>
);

export const HowItWorks = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="special-how-it-works">
    {howItWorks.map((s) => (
      <div key={s.step} className="flex gap-4">
        <span className="font-display italic font-extrabold text-5xl text-red-600 leading-none">{s.step}</span>
        <div>
          <h3 className="font-display uppercase font-bold text-lg text-neutral-950">{s.title}</h3>
          <p className="text-neutral-600 text-sm">{s.text}</p>
        </div>
      </div>
    ))}
  </div>
);

export const Reviews = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="special-reviews">
    {testimonials.slice(0, 2).map((t) => (
      <figure key={t.id} className="bg-white border border-neutral-200 border-l-4 border-l-red-600 rounded-sm p-6">
        <div className="flex gap-1 mb-3">
          {[...Array(t.rating)].map((_, i) => <Star key={`${t.id}-${i}`} className="w-4 h-4 fill-red-600 text-red-600" />)}
        </div>
        <blockquote className="text-neutral-700 italic leading-relaxed">&ldquo;{t.review}&rdquo;</blockquote>
        <figcaption className="mt-3 font-display uppercase font-bold text-neutral-950">{t.name}</figcaption>
      </figure>
    ))}
  </div>
);
